import clsx from 'clsx';
import { Fragment } from 'react';
import { ActorType } from '../../enums/conversation';
import MessageBubble from '../MessageBubble';
import File from './File';
import Widget from './Widget';
import { MessagePart, Message as MessageType } from './index.types';

const contentClass = clsx(
    '[&_a]:text-brand [&_p]:mb-10 [&_ol]:list-decimal [&_ol]:mb-10 [&_ol]:pl-4 [&_ul]:list-disc [&_ul]:mb-10 [&_ul]:pl-4',
    '[&_table]:mb-10 [&_table]:border-collapse [&_table]:text-inherit',
    '[&_th]:px-4 [&_th]:py-2.5 [&_th]:bg-brand-100 [&_th]:border [&_th]:border-secondary [&_th]:whitespace-nowrap',
    '[&_td]:px-4 [&_td]:py-2.5 [&_td]:border [&_td]:border-secondary [&_td]:whitespace-nowrap',
);

type Props = {
    isLastMessage: boolean;
    message: MessageType;
};

function Message({ isLastMessage, message }: Props) {
    const { actor, createdAt } = message;

    const renderText = (messagePart: MessagePart) => {
        if (!messagePart.text) return null;

        return (
            <MessageBubble actor={actor} timestamp={createdAt}>
                {actor.type === ActorType.USER ? (
                    <div>{messagePart.text.content}</div>
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: messagePart.text.content! }} className={contentClass} />
                )}
            </MessageBubble>
        );
    };

    const renderFile = (messagePart: MessagePart) => {
        if (!messagePart.file) return null;

        return <File message={message} fileData={messagePart.file} />;
    };

    const renderWidget = (messagePart: MessagePart) => {
        if (!messagePart.widget) return null;

        return <Widget isLastMessage={isLastMessage} message={message} widgetData={messagePart.widget} />;
    };

    return (
        <div
            className={clsx(
                'flex flex-col gap-5 break-words',
                actor.type === ActorType.USER ? 'items-end pr-20 pl-40' : 'pr-40 pl-20',
            )}
        >
            {message.messageParts.map(
                (item) =>
                    !item.isPrivate && (
                        <Fragment key={item.id}>
                            {renderText(item)}
                            {renderFile(item)}
                            {renderWidget(item)}
                        </Fragment>
                    ),
            )}
        </div>
    );
}

export default Message;
